(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-timeline"]) return;
  try {
    
  if (!customElements.get('build-timeline')) {
    class BuildTimeline extends HTMLElement {
      #handleClick = (event) => {
        const node = event.target.closest('[data-tl-node]');
        if (node) {
          this.#activate(this.nodes.indexOf(node));
          return;
        }
        if (event.target.closest('[data-tl-prev]')) this.#step(-1, '[data-tl-prev]');
        if (event.target.closest('[data-tl-next]')) this.#step(1, '[data-tl-next]');
      };

      #handleBlockSelect = (event) => {
        if (!this.contains(event.target)) return;
        const index = this.nodes.indexOf(event.target);
        if (index >= 0) this.#activate(index);
      };

      connectedCallback() {
        this.nodes = Array.from(this.querySelectorAll('[data-tl-node]'));
        this.panels = Array.from(this.querySelectorAll('[data-tl-panel]'));
        this.rail = this.querySelector('[data-tl-rail]');
        this.fill = this.querySelector('[data-tl-fill]');
        this.liveRegion = this.querySelector('[data-tl-live]');
        this.activeIndex = Math.max(
          0,
          this.nodes.findIndex((node) => node.hasAttribute('aria-current'))
        );
        this.addEventListener('click', this.#handleClick);
        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.#handleBlockSelect);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.#handleBlockSelect);
      }

      #step(delta, selector) {
        const target = Math.min(this.panels.length - 1, Math.max(0, this.activeIndex + delta));
        if (target === this.activeIndex) return;
        this.#activate(target);
        /* the clicked button just got hidden with its panel: keep focus alive */
        const panel = this.panels[target];
        const same = panel.querySelector(selector);
        if (same && !same.disabled) {
          same.focus();
          return;
        }
        const other = panel.querySelector(selector === '[data-tl-prev]' ? '[data-tl-next]' : '[data-tl-prev]');
        if (other && !other.disabled) other.focus();
      }

      #activate(index) {
        if (index < 0 || index >= this.panels.length) return;
        this.activeIndex = index;
        for (const [i, node] of this.nodes.entries()) {
          node.classList.toggle('is-active', i === index);
          node.classList.toggle('is-done', i < index);
          if (i === index) {
            node.setAttribute('aria-current', 'step');
          } else {
            node.removeAttribute('aria-current');
          }
        }
        for (const [i, panel] of this.panels.entries()) {
          panel.hidden = i !== index;
        }
        if (this.fill && this.nodes.length > 1) {
          this.fill.style.width = `${(index / (this.nodes.length - 1)) * 100}%`;
        }
        this.#centerNode(index);
        this.#announce(index);
      }

      #centerNode(index) {
        const node = this.nodes[index];
        if (!this.rail || !node) return;
        const target = node.offsetLeft - this.rail.clientWidth / 2 + node.clientWidth / 2;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollTo({ left: Math.max(0, target), behavior: reduced ? 'auto' : 'smooth' });
      }

      #announce(index) {
        if (!this.liveRegion) return;
        const message = this.panels[index].dataset.announce || '';
        this.liveRegion.textContent = '';
        requestAnimationFrame(() => {
          this.liveRegion.textContent = message;
        });
      }
    }

    customElements.define('build-timeline', BuildTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-belt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drop-belt')) {
    // Desktop mouse drag-to-scroll. Touch is left to the platform, and
    // nothing moves on its own, so there is no timer here to pause.
    //
    // With category tabs there is one rail PER PANEL, but only ONE set of
    // prev/next arrows (in the section head) and only ever one rail visible
    // at a time — a hidden panel has zero dimensions, so `syncNav` and
    // `page` only ever touch `activeRail()`. Drag state is likewise a single
    // object, not one per rail: a hidden rail's pointer events never fire,
    // so only one rail can ever be mid-drag at once.
    const DRAG_THRESHOLD = 5;

    class DropBelt extends HTMLElement {
      connectedCallback() {
        this.rails = Array.from(this.querySelectorAll('[data-belt-rail]'));
        if (!this.rails.length) return;

        // Present only when the section has category blocks; absent for the
        // plain single-rail form, which this class also drives unchanged.
        this.tablist = this.querySelector('[role="tablist"]');
        this.tabs = this.tablist ? Array.from(this.querySelectorAll('[role="tab"]')) : [];
        this.panels = this.tablist ? Array.from(this.querySelectorAll('[role="tabpanel"]')) : [];
        this.activeIndex = 0;

        // The nav lives in the section head, outside this element.
        this.nav = this.closest('.drop-belt')?.querySelector('[data-belt-nav]');
        this.prevBtn = this.nav?.querySelector('[data-belt-prev]');
        this.nextBtn = this.nav?.querySelector('[data-belt-next]');

        this.drag = { rail: null, pointerId: null, startX: 0, startLeft: 0, dragged: false, suppressClick: false };
        this.abort = new AbortController();
        const signal = this.abort.signal;

        for (const rail of this.rails) {
          rail.addEventListener('pointerdown', (event) => this.onDown(event, rail), { signal });
          // A native image/link drag would hijack the gesture mid-pan.
          rail.addEventListener(
            'dragstart',
            (event) => {
              if (this.drag.pointerId !== null) event.preventDefault();
            },
            { signal }
          );
          // Capture phase: a drag's click has to die before it reaches the tile link.
          rail.addEventListener('click', (event) => this.onClick(event, rail), { capture: true, signal });
        }
        // On window, not the rail: a drag that leaves the rail must keep tracking.
        window.addEventListener('pointermove', (event) => this.onMove(event), { signal });
        window.addEventListener('pointerup', (event) => this.onUp(event), { signal });
        window.addEventListener('pointercancel', (event) => this.onUp(event), { signal });

        if (this.tablist) {
          this.tablist.addEventListener('click', (event) => {
            const tab = event.target.closest('[role="tab"]');
            if (!tab) return;
            this.selectTab(this.tabs.indexOf(tab), false);
          }, { signal });
          this.tablist.addEventListener('keydown', (event) => this.onTabsKeydown(event), { signal });

          if (window.Shopify && window.Shopify.designMode) {
            document.addEventListener(
              'shopify:block:select',
              (event) => {
                const tab = event.target.closest && event.target.closest('[role="tab"]');
                if (tab && this.tabs.includes(tab)) this.selectTab(this.tabs.indexOf(tab), false);
              },
              { signal }
            );
          }
        }

        if (this.nav) {
          this.prevBtn?.addEventListener('click', () => this.page(-1), { signal });
          this.nextBtn?.addEventListener('click', () => this.page(1), { signal });
          for (const rail of this.rails) {
            rail.addEventListener('scroll', () => this.syncNav(), { signal, passive: true });
          }
          // A drop that fits needs no controls at all, and the answer changes
          // when the window is resized or a font finally loads. A resize of a
          // hidden rail is harmless: syncNav only ever reads activeRail().
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(() => this.syncNav());
            for (const rail of this.rails) this.ro.observe(rail);
          }
          this.syncNav();
        }
      }

      activeRail() {
        return this.rails[this.activeIndex] || this.rails[0];
      }

      onTabsKeydown(event) {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;
        let next = null;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        this.selectTab(next, true);
      }

      selectTab(index, focus) {
        if (index === this.activeIndex) {
          if (focus) this.tabs[index]?.focus();
          return;
        }
        for (const [i, tab] of this.tabs.entries()) {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !active;
        }
        this.activeIndex = index;
        if (focus) this.tabs[index].focus();
        // The freshly shown rail keeps whatever scroll position it already
        // had (0 the first time); re-sync the arrows to match it now that
        // it is the one with real dimensions.
        this.syncNav();
      }

      // One "page" is a viewport of rail minus a tile's worth of overlap, so a
      // partly-visible tile is never skipped past.
      page(direction) {
        const rail = this.activeRail();
        if (!rail) return;
        const first = rail.querySelector('.drop-belt__item');
        const overlap = first ? first.getBoundingClientRect().width * 0.25 : 0;
        const step = Math.max(120, rail.clientWidth - overlap);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        rail.scrollBy({ left: step * direction, behavior: reduced ? 'auto' : 'smooth' });
      }

      syncNav() {
        if (!this.nav) return;
        const rail = this.activeRail();
        if (!rail) return;
        // 2px of slack: fractional layout widths mean scrollLeft rarely lands
        // exactly on the maximum, which would leave "next" enabled at the end.
        const max = rail.scrollWidth - rail.clientWidth;
        const overflows = max > 2;
        this.nav.hidden = !overflows;
        if (!overflows) return;
        if (this.prevBtn) this.prevBtn.disabled = rail.scrollLeft <= 2;
        if (this.nextBtn) this.nextBtn.disabled = rail.scrollLeft >= max - 2;
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.ro?.disconnect();
      }

      onDown(event, rail) {
        if (event.pointerType === 'touch' || event.button !== 0) return;
        this.drag.rail = rail;
        this.drag.pointerId = event.pointerId;
        this.drag.startX = event.clientX;
        this.drag.startLeft = rail.scrollLeft;
        this.drag.dragged = false;
        this.drag.suppressClick = false;
      }

      onMove(event) {
        const d = this.drag;
        if (d.pointerId === null || event.pointerId !== d.pointerId) return;
        const dx = event.clientX - d.startX;
        if (!d.dragged) {
          // Under the threshold this is still a tap, and the link must fire.
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          d.dragged = true;
          d.rail.classList.add('is-dragging');
        }
        event.preventDefault();
        d.rail.scrollLeft = d.startLeft - dx;
      }

      onUp(event) {
        const d = this.drag;
        if (d.pointerId === null || event.pointerId !== d.pointerId) return;
        d.pointerId = null;
        d.rail.classList.remove('is-dragging');
        d.suppressClick = d.dragged;
        d.dragged = false;
        // A drag released outside the rail fires no click there, so the flag
        // can sit armed. onDown clears it, and every click on a rail is
        // preceded by a pointerdown on that same rail, so it can never
        // swallow a real click. Do NOT clear it on a timer instead: `click`
        // is dispatched in a separate task from `pointerup`, so a
        // setTimeout(0) can win the race, un-suppress the click, and
        // navigate to the product mid-drag.
      }

      onClick(event, rail) {
        const d = this.drag;
        if (d.rail !== rail || !d.suppressClick) return;
        d.suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }
    }

    customElements.define('drop-belt', DropBelt);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drop-countdown"]) return;
  try {
    
  class DropCountdown extends HTMLElement {
    #timerId = null;
    #deadline = NaN;
    #parts = null;

    connectedCallback() {
      this.#deadline = Date.parse(this.dataset.deadline || '');
      if (Number.isNaN(this.#deadline)) {
        this.hidden = true;
        return;
      }
      this.#parts = {
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]'),
      };
      this.#tick();
      if (this.#deadline > Date.now()) {
        this.#timerId = setInterval(() => this.#tick(), 1000);
      }
    }

    disconnectedCallback() {
      if (this.#timerId) clearInterval(this.#timerId);
    }

    #tick() {
      const diff = this.#deadline - Date.now();
      if (diff <= 0) {
        this.#finish();
        return;
      }
      const total = Math.floor(diff / 1000);
      this.#set('days', Math.floor(total / 86400));
      this.#set('hours', Math.floor(total / 3600) % 24);
      this.#set('minutes', Math.floor(total / 60) % 60);
      this.#set('seconds', total % 60);
    }

    #set(part, value) {
      const el = this.#parts[part];
      if (!el) return;
      const text = String(value).padStart(2, '0');
      if (el.textContent !== text) el.textContent = text;
    }

    #finish() {
      if (this.#timerId) clearInterval(this.#timerId);
      this.#timerId = null;
      if (this.dataset.showWhenPast === 'true') {
        this.querySelector('[data-countdown-timer]')?.setAttribute('hidden', '');
        this.querySelector('[data-countdown-date]')?.setAttribute('hidden', '');
        this.querySelector('[data-countdown-live]')?.removeAttribute('hidden');
        return;
      }
      if (window.Shopify && window.Shopify.designMode) return;
      this.closest('.drop-countdown')?.setAttribute('hidden', '');
    }
  }

  if (!customElements.get('drop-countdown')) {
    customElements.define('drop-countdown', DropCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  // "Reach me" links open the Shopify Inbox chat when it is available, and fall
  // back to their own href when it is not. Delegated from the document so it
  // covers the footer link, the FAQ link and anything added later.
  //
  // Why a fallback at all: <shopify-chat> is hidden on phone-sized product pages
  // (it sits on top of Add to bag), and the element is absent entirely if the app
  // is uninstalled. In both cases the Instagram link must still work, so the href
  // stays real and this only intercepts when the chat can actually be opened.
  //
  // show() is a method Shopify Inbox defines on the custom element; verified
  // against the live storefront 2026-08-09 alongside close() and refreshTheme().
  if (!window.__chatFirstBound) {
    window.__chatFirstBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-chat-first]');
      if (!link) return;
      const chat = document.querySelector('shopify-chat');
      if (!chat || typeof chat.show !== 'function') return;
      // A hidden host cannot present a panel, so let the href win instead of
      // swallowing the click and doing nothing visible.
      if (getComputedStyle(chat).display === 'none') return;
      event.preventDefault();
      chat.show();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const nav = document.querySelector('[data-nav]');
    if (!nav) return;
    const toggle = nav.querySelector('[data-menu-toggle]');
    const menu = nav.querySelector('[data-mobile-menu]');
    let menuOpen = false;

    const syncScrolled = () => {
      nav.classList.toggle('is-scrolled', window.scrollY > 24 || menuOpen);
    };
    window.addEventListener('scroll', syncScrolled, { passive: true });
    syncScrolled();

    const setMenu = (open) => {
      menuOpen = open;
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      syncScrolled();
    };

    toggle.addEventListener('click', () => setMenu(!menuOpen));

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !menuOpen) return;
      setMenu(false);
      toggle.focus();
    });

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setMenu(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-controls')) {
    class MarqueeControls extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-marquee-pause]');
        this.tracks = this.querySelectorAll('[data-marquee-track]');
        if (!this.button || !this.tracks.length) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#setPaused(reducedMotion);

        this.button.addEventListener('click', () => {
          this.#setPaused(this.button.getAttribute('aria-pressed') !== 'true');
        });
      }

      #setPaused(paused) {
        this.button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        const glyph = this.button.querySelector('[data-marquee-pause-glyph]');
        if (glyph) glyph.textContent = paused ? '▶' : '❚❚';
        // Host attributes, not inline styles: an inline play-state would
        // out-specify the :hover pause in app.css. data-user-play only has
        // an effect under prefers-reduced-motion (explicit play override).
        this.toggleAttribute('data-paused', paused);
        this.toggleAttribute('data-user-play', !paused);
      }
    }

    customElements.define('marquee-controls', MarqueeControls);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-controls')) {
    class MarqueeControls extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-marquee-pause]');
        this.tracks = this.querySelectorAll('[data-marquee-track]');
        if (!this.button || !this.tracks.length) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#setPaused(reducedMotion);

        this.button.addEventListener('click', () => {
          this.#setPaused(this.button.getAttribute('aria-pressed') !== 'true');
        });
      }

      #setPaused(paused) {
        this.button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        const glyph = this.button.querySelector('[data-marquee-pause-glyph]');
        if (glyph) glyph.textContent = paused ? '▶' : '❚❚';
        this.toggleAttribute('data-paused', paused);
        this.toggleAttribute('data-user-play', !paused);
      }
    }

    customElements.define('marquee-controls', MarqueeControls);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-grid-tabs')) {
    class ProductGridTabs extends HTMLElement {
      #abort = null;

      connectedCallback() {
        this.tablist = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tablist || !this.tabs.length) return;

        this.#abort = new AbortController();

        this.tablist.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (!tab) return;
          this.select(this.tabs.indexOf(tab), false);
        });

        this.tablist.addEventListener('keydown', (event) => this.#onKeydown(event));

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const tab = event.target.closest && event.target.closest('[role="tab"]');
              if (tab && this.tabs.includes(tab)) this.select(this.tabs.indexOf(tab), false);
            },
            { signal: this.#abort.signal }
          );
        }
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }

      #onKeydown(event) {
        const current = this.tabs.indexOf(document.activeElement);
        if (current === -1) return;
        let next = null;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        this.select(next, true);
      }

      select(index, focus) {
        for (const [i, tab] of this.tabs.entries()) {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !active;
        }
        if (focus) this.tabs[index].focus();
      }
    }

    customElements.define('product-grid-tabs', ProductGridTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const QTY_MAX = 10;

    const money = (cents, currency) => {
      const whole = cents % 100 === 0;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency || 'USD',
          minimumFractionDigits: whole ? 0 : 2,
          maximumFractionDigits: whole ? 0 : 2,
        }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(whole ? 0 : 2);
      }
    };

    const clampQty = (value) => {
      const qty = Math.round(Number(value));
      if (!Number.isFinite(qty)) return 1;
      return Math.max(1, Math.min(QTY_MAX, qty));
    };

    const syncBuy = (root) => {
      const input = root.querySelector('[data-qty-input]');
      const label = root.querySelector('[data-add-label]');
      const button = root.querySelector('[data-add-to-cart]');
      if (!input || !label || !button || button.disabled) return;
      input.value = clampQty(input.value);
      const total = Number(root.dataset.currentPrice) * Number(input.value);
      const template = button.dataset.addTemplate || '[price]';
      label.textContent = template.replace('[price]', money(total, root.dataset.currency));
    };

    const announce = (root, message) => {
      const region = root.querySelector('[data-variant-live]');
      if (!region) return;
      region.textContent = '';
      requestAnimationFrame(() => {
        region.textContent = message;
      });
    };

    const selectMedia = (root, thumb) => {
      for (const image of root.querySelectorAll('[data-media-index]')) {
        image.hidden = image.dataset.mediaIndex !== thumb.dataset.mediaThumb;
      }
      for (const other of root.querySelectorAll('[data-media-thumb]')) {
        const active = other === thumb;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-current', active ? 'true' : 'false');
      }
    };

    const getVariantData = (root) => {
      const el = root.querySelector('[data-variant-data]');
      if (!el) return [];
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return [];
      }
    };

    const colorGroup = (root) =>
      Array.from(root.querySelectorAll('[data-option-group]')).find((group) =>
        group.querySelector('.optchip')
      ) || null;

    // Selected value per option position: rendered groups win; hidden
    // single-value positions come from the variant in the hidden input.
    const selectedValues = (root) => {
      const data = getVariantData(root);
      const idInput = root.querySelector('[data-variant-id]');
      const current =
        data.find((v) => String(v.id) === String(idInput && idInput.value)) || data[0];
      const values = current ? [...current.options] : [];
      for (const group of root.querySelectorAll('[data-option-group]')) {
        const active = group.querySelector('.is-active');
        if (active) values[Number(group.dataset.optionIndex)] = active.dataset.optionValue;
      }
      return values;
    };

    const matchVariant = (data, values) =>
      data.find((v) => v.options.every((opt, i) => opt === values[i])) || null;

    // Cascade: a value is offered if an available variant matches it plus
    // every selection in groups ABOVE it (DOM order). Color sits first, so
    // colors are judged product-wide and sizes within the chosen color.
    const markAvailability = (root) => {
      const data = getVariantData(root);
      const values = selectedValues(root);
      const addBtn = root.querySelector('[data-add-to-cart]');
      const soldoutLabel = (addBtn && addBtn.dataset.soldoutLabel) || '';
      const notInColorTemplate = root.dataset.notInColorTemplate || '';
      const activeChip = colorGroup(root) && colorGroup(root).querySelector('.is-active');
      const activeColor = activeChip ? activeChip.dataset.optionValue : '';
      const constraints = [];
      for (const group of root.querySelectorAll('[data-option-group]')) {
        const idx = Number(group.dataset.optionIndex);
        for (const btn of group.querySelectorAll('[data-option-value]')) {
          const matches = (v) =>
            v.options[idx] === btn.dataset.optionValue &&
            constraints.every((c) => v.options[c.idx] === c.value);
          // "Never offered" and "sold out" are different facts and the store
          // currently has only the first: no variant anywhere is out of
          // stock, yet the hoodie's Sport Grey struck through M/L/XL as if
          // they were. A size the colourway does not come in is not shown.
          const exists = data.some(matches);
          const ok = data.some((v) => v.available && matches(v));
          // Sold-out COLOR chips stay selectable — a shopper must still be
          // able to open a sold-out colorway to browse its photos. They keep
          // the dimmed/struck styling and the sold-out note, but never carry
          // aria-disabled, so neither the click guard nor the arrow-key
          // handler discards them. Selecting one leaves every size sold out
          // and add-to-bag disabled, which applyVariant already handles.
          // Size buttons keep the old blocking behaviour.
          const isChip = btn.classList.contains('optchip');
          // The whole size run stays on screen so a shopper can see what the
          // product is made in, but "not made in this colour" and "sold out"
          // are different facts and must not share a label: nothing in the
          // store is actually out of stock, yet Sport Grey was reporting
          // M/L/XL as sold out when it is simply not made in them.
          if (!isChip) btn.classList.toggle('is-unavailable', !exists);
          btn.classList.toggle('is-soldout', exists && !ok);
          if (ok || isChip) btn.removeAttribute('aria-disabled');
          else btn.setAttribute('aria-disabled', 'true');
          // aria-disabled alone is not announced as a reason; keep the
          // visually-hidden note in sync so screen readers hear which one.
          const note = btn.querySelector('[data-soldout-text]');
          let reason = '';
          if (!ok) {
            reason = exists
              ? soldoutLabel
              : notInColorTemplate.replace('[color]', activeColor);
          }
          if (!reason) {
            if (note) note.remove();
          } else {
            const span = note || document.createElement('span');
            span.className = 'visually-hidden';
            span.setAttribute('data-soldout-text', '');
            // Leading NBSP keeps the accessible name as "3XL Sold out",
            // not "3XLSold out" (what the old server-rendered span did).
            span.textContent = '\u00A0' + reason;
            if (!note) btn.append(span);
          }
        }
        constraints.push({ idx, value: values[idx] });
      }
    };

    // Switching colour can leave the selected size pointing at a variant
    // that does not exist (Sport Grey is not made in M), which kills
    // add-to-bag with no visible reason. Move to a size the new colourway
    // is actually made in. Colour chips are exempt — a shopper must still
    // be able to open a colourway to browse its photos.
    const reconcileSelection = (root) => {
      let moved = false;
      for (const group of root.querySelectorAll('[data-option-group]')) {
        if (group.querySelector('.optchip')) continue;
        const options = Array.from(group.querySelectorAll('[data-option-value]'));
        const usable = (b) =>
          !b.classList.contains('is-unavailable') && !b.classList.contains('is-soldout');
        const active = options.find((b) => b.classList.contains('is-active'));
        if (active && usable(active)) continue;
        const fallback =
          options.find(usable) || options.find((b) => !b.classList.contains('is-unavailable'));
        if (!fallback || fallback === active) continue;
        for (const other of options) {
          const isActive = other === fallback;
          other.classList.toggle('is-active', isActive);
          other.setAttribute('aria-checked', isActive ? 'true' : 'false');
          other.tabIndex = isActive ? 0 : -1;
        }
        moved = true;
      }
      return moved;
    };

    // Sort, don't hide. Selecting a colorway re-partitions the rail three ways
    // and removes nothing, so a stale, wrong or missing label costs ordering
    // and never correctness — there is no reachable state where the gallery is
    // empty or a photo is unreachable. Replaces the old `hidden` cascade.
    const sortGallery = (root, preferredIndex) => {
      const rail = root.querySelector('.pdp__thumbs');
      const group = colorGroup(root);
      const active = group && group.querySelector('.is-active');
      const color = active ? active.dataset.optionValue.toLowerCase() : '';
      const thumbs = Array.from(root.querySelectorAll('[data-media-thumb]'));
      const bucketOf = (thumb) => {
        const tag = (thumb.dataset.color || '').trim();
        if (!tag) return 1;
        return tag === color ? 0 : 2;
      };

      if (rail && color) {
        // Moving real nodes rather than setting CSS `order` keeps DOM order,
        // visual order and tab order identical.
        const buckets = [[], [], []];
        for (const thumb of thumbs) buckets[bucketOf(thumb)].push(thumb);
        // Group the other-colourways bucket by colour. Printify ships an
        // interleaved header — one photo per colourway before the grouped
        // detail blocks — so leaving this bucket in document order means that
        // when nothing is hidden (a colourway with no photography of its own)
        // the rail reads black, white, sand, navy, black, white, sand, navy.
        const grouped = [];
        const seen = new Set();
        for (const thumb of buckets[2]) {
          const tag = (thumb.dataset.color || '').trim();
          if (seen.has(tag)) continue;
          seen.add(tag);
          for (const other of buckets[2]) {
            if ((other.dataset.color || '').trim() === tag) grouped.push(other);
          }
        }
        for (const bucket of [buckets[0], buckets[1], grouped]) {
          for (const thumb of bucket) rail.appendChild(thumb);
        }
        // appendChild does not move the rail's existing scroll offset, so a
        // shopper scrolled into the tail would see the wrong end of a correct
        // order. Instant, never smooth: content that just teleported must not
        // also appear to animate.
        rail.scrollLeft = 0;
      }

      // Show only the chosen colorway (JO, 08-06). Photos of another colorway
      // are hidden; untagged ones stay, since they carry no claim to contradict.
      // The sort above still runs, so the rail is in colorway order underneath
      // and re-showing everything is one line away.
      const own = thumbs.filter((t) => bucketOf(t) === 0).length;
      for (const thumb of thumbs) {
        // Never an empty rail: a colorway with no photography of its own keeps
        // the whole set rather than filtering everything away.
        thumb.hidden = Boolean(color) && own > 0 && bucketOf(thumb) === 2;
      }

      // A rail holding one thumbnail is 79px restating the photo directly above
      // it. On the hats and the rope cap, where Printify ships exactly one photo
      // per colourway, that pushed the colour chips 5px below the fold on a
      // 390x844 phone. Hiding it moves them from y=849 to y=758, so a full row
      // of colours lands on the first screen. Products with two or more photos
      // per colourway keep their rail, because there the thumbs do something.
      // NOTE: .pdp__thumbs is display:grid, and a `display` rule beats the UA
      // [hidden] rule, so app.css carries an explicit .pdp__thumbs[hidden]
      // declaration. Without it this line silently does nothing.
      if (rail) rail.hidden = thumbs.filter((t) => !t.hidden).length <= 1;

      let target =
        preferredIndex === null || preferredIndex === undefined
          ? null
          : root.querySelector(`[data-media-thumb="${preferredIndex}"]`);
      if (target && target.hidden) target = null;
      if (!target) {
        const activeThumb = root.querySelector('[data-media-thumb].is-active');
        if (activeThumb && !activeThumb.hidden && bucketOf(activeThumb) < 2) return;
        target = rail
          ? rail.querySelector('[data-media-thumb]:not([hidden])')
          : thumbs.find((t) => !t.hidden);
      }
      if (target) selectMedia(root, target);
    };

    // The sticky bar only proxies the real add button, so it has to mirror
    // that button's state — otherwise it stays a tappable "Add to bag" that
    // silently no-ops. Its original label is captured once, on first swap.
    const syncSticky = (root, purchasable) => {
      const sticky = root.querySelector('[data-sticky-add]');
      if (!sticky) return;
      const label = sticky.querySelector('span');
      if (label) {
        if (sticky.dataset.stickyLabel === undefined) {
          sticky.dataset.stickyLabel = label.textContent;
        }
        const addBtn = root.querySelector('[data-add-to-cart]');
        label.textContent = purchasable
          ? sticky.dataset.stickyLabel
          : (addBtn && addBtn.dataset.soldoutLabel) || '';
      }
      sticky.disabled = !purchasable;
    };

    const applyVariant = (root, changedValue) => {
      const data = getVariantData(root);
      const values = selectedValues(root);
      const variant = matchVariant(data, values);
      const idInput = root.querySelector('[data-variant-id]');
      const addBtn = root.querySelector('[data-add-to-cart]');
      const label = root.querySelector('[data-add-label]');

      let mediaIndex = null;
      if (variant) {
        if (idInput) idInput.value = variant.id;
        root.dataset.currentPrice = variant.price;
        const priceEl = root.querySelector('[data-price]');
        if (priceEl) priceEl.textContent = money(variant.price, root.dataset.currency);
        const stickyPrice = document.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = money(variant.price, root.dataset.currency);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(null, '', url);
        mediaIndex = variant.media_index;
      } else {
        // combo missing entirely: keep the gallery on the chosen color
        const group = colorGroup(root);
        const active = group && group.querySelector('.is-active');
        if (active) {
          const idx = Number(group.dataset.optionIndex);
          const sample =
            data.find(
              (v) => v.options[idx] === active.dataset.optionValue && v.media_index !== null
            ) || null;
          if (sample) mediaIndex = sample.media_index;
        }
      }

      const purchasable = Boolean(variant && variant.available);
      if (addBtn) {
        addBtn.disabled = !purchasable;
        if (!purchasable && label) label.textContent = addBtn.dataset.soldoutLabel || '';
      }
      syncSticky(root, purchasable);
      if (purchasable) syncBuy(root);

      markAvailability(root);
      // Recompute once against the corrected selection. reconcileSelection
      // only reports a move when the new active option is visible, so the
      // second pass always settles.
      if (reconcileSelection(root)) {
        applyVariant(root, changedValue);
        return;
      }
      sortGallery(root, mediaIndex);

      if (changedValue) {
        const template = root.dataset.variantSelectedTemplate || '[variant]';
        announce(root, template.replace('[variant]', changedValue));
      }
    };

    const selectOption = (root, button) => {
      const group = button.closest('[data-option-group]');
      for (const other of group.querySelectorAll('[data-option-value]')) {
        const isActive = other === button;
        other.classList.toggle('is-active', isActive);
        other.setAttribute('aria-checked', isActive ? 'true' : 'false');
        other.tabIndex = isActive ? 0 : -1;
      }
      applyVariant(root, button.dataset.optionValue);
    };

    // Delegated so Theme Editor section re-renders keep working without rebinding.
    document.addEventListener('click', (event) => {
      const root = event.target.closest('[data-product-detail]');
      if (!root) return;

      const thumb = event.target.closest('[data-media-thumb]');
      if (thumb) {
        selectMedia(root, thumb);
        return;
      }

      const option = event.target.closest('[data-option-value]');
      if (option) {
        if (option.getAttribute('aria-disabled') === 'true') return;
        selectOption(root, option);
        return;
      }

      const step = event.target.closest('[data-qty-change]');
      if (step) {
        const input = root.querySelector('[data-qty-input]');
        if (!input) return;
        input.value = clampQty(Number(input.value) + Number(step.dataset.qtyChange));
        syncBuy(root);
      }
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-qty-input]')) return;
      const root = event.target.closest('[data-product-detail]');
      if (root) syncBuy(root);
    });

    // Roving tabindex for the size radiogroup: arrow keys move focus and, for
    // available sizes, select as they go (matching the tabs component).
    // Sold-out radios stay reachable by arrow key but are not activated —
    // the click guard above enforces the same rule for pointer input.
    document.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) {
        return;
      }
      // Chorded presses belong to the browser (Alt+Left = back, Cmd+Down = end
      // of document); claiming them would preventDefault and swap the variant.
      if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) return;
      const group = event.target.closest('[data-option-group]');
      if (!group) return;
      const root = group.closest('[data-product-detail]');
      if (!root) return;

      const options = Array.from(group.querySelectorAll('[data-option-value]'));
      const current = options.indexOf(event.target);
      if (current === -1) return;

      let next = current;
      // Chip rows wrap onto a second line at phone width, so APG's
      // Down = Right / Up = Left equivalence is what makes them navigable.
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = (current + 1) % options.length;
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = (current - 1 + options.length) % options.length;
      }
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = options.length - 1;
      event.preventDefault();

      const target = options[next];
      if (target.getAttribute('aria-disabled') === 'true') {
        for (const [i, opt] of options.entries()) opt.tabIndex = i === next ? 0 : -1;
        target.focus();
      } else {
        selectOption(root, target);
        target.focus();
      }
    });

    // Visible add-to-cart failure message (cart.js only announces to a live
    // region and dispatches this event; nothing else showed it on screen).
    document.addEventListener('cart:error', (event) => {
      for (const errorEl of document.querySelectorAll('[data-cart-error]')) {
        errorEl.textContent = event.detail?.message || '';
        errorEl.hidden = false;
      }
    });
    document.addEventListener('cart:updated', () => {
      for (const errorEl of document.querySelectorAll('[data-cart-error]')) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    });

    // Observers are the only non-delegated binding left, so they are tracked
    // and torn down before a repaint — a theme-editor session repaints on
    // every setting change and would otherwise stack one observer per edit.
    let stickyObservers = [];

    // Server-rendered selection is authoritative; this only paints the
    // derived state (sold-out cascade, color-filtered gallery) on top.
    const paint = (root) => {
      markAvailability(root);
      sortGallery(root, null);
      // A server-rendered sold-out variant leaves the sticky bar live too.
      const addBtn = root.querySelector('[data-add-to-cart]');
      syncSticky(root, Boolean(addBtn) && !addBtn.disabled);

      // Mobile sticky add-to-cart: shows once the buy form leaves the viewport
      // and proxies the real add button (state, errors, and announcements all
      // stay in one place). The bar is display:none above 880px regardless.
      const stickyBar = root.querySelector('[data-sticky-cta]');
      // Watch the add button itself, NOT #ProductForm. The form is ~660px tall
      // on a phone (nine colour chips), so observing it kept the bar hidden
      // until the form's BOTTOM cleared the viewport — measured 2026-08-09 on a
      // 390x844 viewport, the bar appeared at scrollY 1400 for a real button at
      // y=1426. It only ever arrived once the thing it substitutes for was
      // already on screen, which is why the client had to swipe past the
      // gallery to reach Add to bag. Observing the button makes the bar present
      // from first paint and hides it exactly when the real button is reachable.
      const buyTarget = root.querySelector('[data-add-to-cart]') || root.querySelector('#ProductForm');
      if (stickyBar && buyTarget && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          stickyBar.hidden = entry.isIntersecting;
        }, { rootMargin: '-80px 0px 0px 0px' });
        observer.observe(buyTarget);
        stickyObservers.push(observer);
      }
    };

    // Theme Editor setting changes replace the section HTML without re-running
    // this script, so the paint has to run again on the fresh DOM. The event
    // target is the section wrapper, but treat it as a root too in case the
    // element carrying [data-product-detail] is the target itself.
    const paintAll = (scope) => {
      const roots = [];
      if (scope.matches && scope.matches('[data-product-detail]')) roots.push(scope);
      roots.push(...scope.querySelectorAll('[data-product-detail]'));
      if (roots.length === 0) return;
      for (const observer of stickyObservers) observer.disconnect();
      stickyObservers = [];
      for (const root of roots) paint(root);
    };

    paintAll(document);
    document.addEventListener('shopify:section:load', (event) => {
      paintAll(event.target);
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-sticky-add]')) return;
      const addBtn = document.querySelector('[data-product-detail] [data-add-to-cart]');
      if (addBtn && !addBtn.disabled) addBtn.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sponsor-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-controls')) {
    class MarqueeControls extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-marquee-pause]');
        this.tracks = this.querySelectorAll('[data-marquee-track]');
        if (!this.button || !this.tracks.length) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.#setPaused(reducedMotion);

        this.button.addEventListener('click', () => {
          this.#setPaused(this.button.getAttribute('aria-pressed') !== 'true');
        });
      }

      #setPaused(paused) {
        this.button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        const glyph = this.button.querySelector('[data-marquee-pause-glyph]');
        if (glyph) glyph.textContent = paused ? '▶' : '❚❚';
        // Host attributes, not inline styles: an inline play-state would
        // out-specify the :hover pause in app.css. data-user-play only has
        // an effect under prefers-reduced-motion (explicit play override).
        this.toggleAttribute('data-paused', paused);
        this.toggleAttribute('data-user-play', !paused);
      }
    }

    customElements.define('marquee-controls', MarqueeControls);
  }

  } catch(e) { console.error(e); }
})();
})();
